import React from 'react';

import { Tag } from 'antd';
import { Icon } from '@eduzz/ui-antd-theme';

const DraftLabel = () => {
  return (
    <Tag
      className='w-min'
      color='warning'
      icon={<Icon.CircleAlert color='orange'  />}
    >
      Rascunho
    </Tag>
  );
};

export default DraftLabel;
